import { html, TemplateResult } from "lit";
import { Kernel } from "../Kernel";

export function litIf(
    value: boolean | any | undefined | null,
    template: () => TemplateResult,
    elseTemplate: (() => TemplateResult) | undefined = undefined
): TemplateResult {
    if (value) {
        return typeof template === "function" ? template() : template;
    }
    return typeof elseTemplate === "function" ? elseTemplate() : (elseTemplate ?? html``);
}

export function litIfUserInGroup(group: string, template: () => TemplateResult): TemplateResult {
    return litIf(Kernel.instance().user?.inGroup(group) ?? false, template);
}

export function litIfSignedIn(template: () => TemplateResult) {
    return litIf(Kernel.instance().user, template);
}
